import { render } from "./ModalCongratulation.vue?vue&type=template&id=416003fa&scoped=true"
import script from "./ModalCongratulation.vue?vue&type=script&lang=js"
export * from "./ModalCongratulation.vue?vue&type=script&lang=js"

import "./ModalCongratulation.vue?vue&type=style&index=0&id=416003fa&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-416003fa"]])

export default __exports__